import { useEffect } from 'react'
import { type Path } from 'react-router-dom'

import AnimatingLogo from '@src/app/components/AnimatingLogo'
import { PROTOCOL_QUO_DESKTOP } from '@src/app/url/URLRouter/CustomProtocolHandler'
import Button from '@ui/Button/Button'
import Typography from '@ui/Typography'

import * as styles from './Callback.css'

export default function RedirectInElectronApp({
  to,
}: {
  to: Pick<Path, 'pathname' | 'search'>
}) {
  useEffect(() => {
    const pathname = to.pathname.startsWith('/') ? to.pathname.slice(1) : to.pathname

    window.location.href = `${PROTOCOL_QUO_DESKTOP}://${pathname}${to.search}`
  }, [to.pathname, to.search])

  return (
    <div className={styles.root}>
      <AnimatingLogo />
      <Typography
        style={{ marginTop: 30 }}
        variant="body"
        color="textSecondary"
        component="p"
      >
        Opening the desktop app...
      </Typography>
      <Button style={{ marginTop: 10 }} variant="ghost" onClick={() => window.close()}>
        Close window
      </Button>
    </div>
  )
}
